import React from 'react';
import { Navigate, useParams } from 'react-router-dom';
import { useAuth } from './AuthContext';

const ProtectedRoute = ({ children }) => {
  const { user } = useAuth(); // Use the custom hook for better consistency
  const { customerId } = useParams(); // Extract customerId from the URL

  if (!user) {
    // Redirect to the dynamic login path if the user is not authenticated
    return <Navigate to={`/customer/${customerId}/login`} replace />;
  }

  // Render the children if the user is authenticated
  return children;
};

export default ProtectedRoute;
